import React from "react";
import ActionsPopup from "../ActionsPopup";
import schema from "../ActionsPopup/employer_pocs_actions";
import cellGenerator from "./columnUtils";

const employer_pocs_columns = (isSubaccount) => [
  {
    Header: "Profile Name",
    accessor: "POCFormData.poc_emp_profile_name",
    Cell: (props) => cellGenerator(props),
  },
  {
    Header: "Last Name",
    accessor: "POCFormData.poc_emp_last_name",
    Cell: (props) => cellGenerator(props),
  },
  {
    Header: "First Name",
    accessor: "POCFormData.poc_emp_first_name",
    Cell: (props) => cellGenerator(props),
  },
  {
    id: "actions",
    Header: "Actions",
    accessor: (d) => d,
    fixedWidth: 130,
    disableSortBy: true,
    isButton: true, // removes padding and positioning
    Cell: ({ row: { original } }) => (
      <ActionsPopup
        actionsPopupSchema={schema("employer-pocs", isSubaccount)}
        id={original.id}
      />
    ),
  },
];

export default employer_pocs_columns;
